import React, { useEffect, useState } from 'react'
import { Modal, Steps, Form   } from 'antd' 
import { useFYspjdListQuery } from '../../../store/DianShangYeWuApi';
function ExpenseNodeCheck(props) {
    const {data, isSuccess} = useFYspjdListQuery({fy_spjd_qy_id:props.qy_id,fy_spjd_user_id:props.user_id},{skip:!props.user_id});
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const newArr = data.Result.map(item => {
                    const {fy_spjd_id:key,fy_spjd_name,fy_spjd_yh_name,fy_spjd_content,fy_spjd_xuhao,} = item;
                    return {
                        key,
                        title: fy_spjd_name + '：' + fy_spjd_yh_name,
                        content: fy_spjd_content,
                        fy_spjd_xuhao: fy_spjd_xuhao,
                        status: 'wait',
                    }
                })
                const sortArr = newArr.sort( (a, b) => {
                    return a.fy_spjd_xuhao - b.fy_spjd_xuhao;
                })                    
                setItems(sortArr);
                
            } else {
                setItems([]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.fy_spjd_user_name])
    const [open, setOpen] = useState(false);    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.fy_spjd_user_name}</a>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => {}}
                footer={null}
            >
                <Form 
                    form={form} 
                    layout='horizontal' 
                    labelCol={{ span: 6 }}
                    name={`form_check_${props.fy_spjd_user_id}`}
                >
                    <Form.Item label="费用单操作员" >
                        {props.fy_spjd_user_name}
                    </Form.Item>
                    <Form.Item label="审批点">
                        <div style={{ marginTop: '30px' }}>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>                        
                </Form>
            </Modal>
        </>
    )
}
export default ExpenseNodeCheck